<template>
    <section class="content">
        <div class="box">
            <div class="box-header with-border">
                <h3 class="box-title">Admin Settings</h3>
            </div>
            <div class="box-body" style="height: 100%;min-height: 700px;">
                <div class="row">
                    <div class="col-5 col-sm-3 sideborder">
                        <ul class="nav nav-pills nav-stacked post">
                            <li v-bind:class="{'active': tabOne}" @click="tabOne = true, tabTwo = false, tabThree = false, selectedSkillId = ''"><a>Skills</a></li>
                            <li v-bind:class="{'active': tabTwo}" @click="tabOne = false, tabTwo = true, tabThree = false, selectedSkillId = ''"><a>Add Skill</a></li>
                            <li v-bind:class="{'active': tabThree}" @click="tabOne = false, tabTwo = false, tabThree = true, selectedSkillId = ''"><a>Interviewers</a></li>
                        </ul>
                    </div>
                    <div class="col-sm-9">
                        <div v-if="tabOne">
                            <div class="box-header with-border" style="padding: 11px;">
                                <h3 class="box-title">Skills</h3>
                                <div class="box-tools pull-right ">
                                  <div class="filterdata">
                                    <div class="searchinput">
                                        <input
                                            v-model="skillSearch"
                                            type="text"
                                            class=" search-text"
                                            placeholder="Search.."
                                        />
                                        <!-- @keyup="getRelaventProfiles" -->
                                        <button @click="getSkillList()"><i class="fa fa-search" ></i></button>
                                        &nbsp;&nbsp; <button v-if="skillSearch.length > 0" @click="skillSearch =''; getSkillList()">Clear</button>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div style="margin-top: 25%;text-align:center" v-if="skillslistlength < 1">
                                <img src="../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                            </div>
                            <table class="table" v-if="skillslistlength > 0">
                                <tbody>
                                    <tr style="background-color: #cccccc57;">
                                        <td>Skill Name</td>
                                        <td>Skill Id</td>
                                        <td>Action</td>
                                    </tr>
                                    <tr v-for="x in skillslist" :key="x.id">
                                        <td>{{x.name}}</td>
                                        <td>{{x.id}}</td>
                                        <td><a @click="viewInterviewers(x.id)">View Interviewers</a></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="row" v-if="skillslistlength > 9">
                                <div class="col-sm-12">
                                  <jw-pagination :items="exampleItems" @changePage="onChangePage"></jw-pagination>
                                </div>
                            </div>
                        </div>
                        <div v-if="tabTwo">
                            <div class="box-header with-border" style="padding: 11px;">
                                <h3 class="box-title">Add Skill</h3>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-9"><input type="text" placeholder="Skill Name*" class="form-control" v-model.lazy.trim="skillName" /></div>
                                <div class="col-sm-3"><button type="submit" class="btn btn-success " @click="addSkill()">Add</button></div>
                            </div>
                        </div>
                        <div v-if="tabThree">
                            <div class="box-header with-border" style="padding: 11px;">
                                <h3 class="box-title">Interviewers</h3>
                                <div class="box-tools pull-right">
                                    <div class="filterdata">
                                        <div class="searchinput">
                                            <input
                                                v-model="intSearch"
                                                type="text"
                                                class=" search-text"
                                                placeholder="Search.."
                                            />
                                            <!-- @keyup="getRelaventProfiles" -->
                                            <button @click="getInterviewerList()"><i class="fa fa-search" ></i></button>
                                            &nbsp;&nbsp; <button v-if="intSearch.length > 0" @click="intSearch =''; getInterviewerList()">Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 25%;text-align:center" v-if="skillslistlength < 1">
                                <img src="../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                            </div>
                            <table class="table" v-if="intlistlength > 0">
                                <tbody>
                                    <tr style="background-color: #cccccc57;">
                                        <td>Details</td>
                                        <td>Email & Mobile</td>
                                        <td>Action</td>
                                    </tr>
                                    <tr v-for="x in intlist" :key="x.id">
                                        <td>
                                            <div style="display: flex; flex-direction: row;">
                                                <img
                                                v-if="x.profile_pic !='' && x.profile_pic !=null"
                                                :src="`${x.profile_pic}`"
                                                class="round"
                                                />
                                                <img
                                                v-if="x.profile_pic =='' || x.profile_pic ==null"
                                                src="../assets/img/default.png"
                                                class="round"
                                                />
                                                <div>
                                                    <div>{{x.first_name}} {{x.last_name}}</div>
                                                    <span :title="x.designation" class="product-description overflow">
                                                        <span  class="skill-lable">Designation :</span>
                                                        {{x.designation}}
                                                    </span>
                                                    <span :title="x.primarySkillName" class="overflow product-description">
                                                        <span class="skill-lable">skills :</span>
                                                        {{x.primarySkillName}}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div :title="x.email" class=" product-description">
                                                <span class="skill-lable">Email :</span>
                                                {{x.email}}
                                            </div>
                                            <div :title="x.mobile" class=" product-description">
                                                <span class="skill-lable">Mobile :</span>
                                                {{x.mobile}}
                                            </div>
                                        </td>
                                        <td><a @click="openAddSkill(x.id)">Add Skill</a></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="row" v-if="intlistlength > 9">
                                <div class="col-sm-12">
                                  <jw-pagination :items="exampleItems1" @changePage="onChangePage1"></jw-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal overlay fade in" id="modal-default" style="display: block;" v-show="showAddSkillModal">
            <div class="modal-dialog" role="document">
              <div class="modal-content AvailabilityPopup">
                <div class="modal-header">
                  <h3 class="modal-title">
                    <span>Add Skill</span>
                    <button
                      type="button"
                      class="close"
                      @click="onClose()"
                    >
                      <span aria-hidden="true" class="modalClose">&times;</span>
                    </button>
                  </h3>
                </div>
                <div class="modal-body" style="padding:0px">
                    <div class="card-body">
                        <b-form class="register-form" id="resets" v-on:submit.prevent="onSubmitAddSkill" novalidate>
                            <div class="col-md-12">
                                <input type="submit" value="Save" style="width: 93px;height: 30px;" class="submit pull-right" name="submit" id="submit" />
                                <div>
                                    <button type="button" @click="cancel()" style="width: 93px;height: 30px;font-size: 16px;padding: 2px;" class="btn btn-default pull-right mr-2">Cancel</button>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="">
                                    <div class="col-md-12 form-group">
                                        <label>Skill Id</label>
                                        <b-form-input type="text" v-model.lazy.trim="$v.form.skill_id.$model" placeholder="Skill Id*" :state="chkState('skill_id')"/>
                                        <div v-if="$v.form.skill_id.$error">
                                        <p v-if="!$v.form.skill_id.required" class="login-alert-msg error-content">* Enter the Skill Id</p>
                                        </div>
                                    </div>
                                    <div class="col-md-12 form-group">
                                        <label>Rating(0-5)</label>
                                        <b-form-input type="text" v-model.lazy.trim="$v.form.rating.$model" placeholder="Rating*" :state="chkState('rating')"/>
                                        <div v-if="$v.form.rating.$error">
                                        <p v-if="!$v.form.rating.required" class="login-alert-msg error-content">* Enter the Rating</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 form-group">
                                    <label>Overall Experience</label>
                                    <div class="form-row">
                                      <div class="form-group">
                                        <div class="form-select">
                                          <select v-model="form.year" class="form-control" v-bind:class="{ 'is-invalid': !chkState('year') }">
                                            <option value='' disabled>Select Year *</option>
                                            <option value="1">1 year</option>
                                            <option v-for="(x, index) in 20" v-bind:value="x + 1" :key="index">{{x + 1}} years</option>
                                          </select>
                                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                                        </div>
                                        <div v-if="$v.form.year.$error">
                                          <p v-if="!$v.form.year.required" class="login-alert-msg error-content">* Select the year</p>
                                        </div>
                                      </div>
                                      <div class="form-group">
                                        <div class="form-select">
                                          <select id="month" v-model="form.month" class="form-control" v-bind:class="{ 'is-invalid': !chkState('month') }">
                                            <option value='' disabled>Select Month *</option>
                                            <option value="0">0 month</option>
                                            <option value="1">1 month</option>
                                            <option v-for="(x, index) in 10" v-bind:value="x +1" :key="index">{{x + 1}} months</option>
                                          </select>
                                          <span for="month" class="select-icon"><i class="fa fa-chevron-down"></i></span>
                                        </div>
                                        <div v-if="$v.form.month.$error">
                                          <p v-if="!$v.form.month.required" class="login-alert-msg error-content">* Select the month</p>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <br>
                            </div>
                        </b-form>
                    </div>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import JwPagination from 'jw-vue-pagination'
// import router from '../router/index'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Vue from 'vue'
Vue.component('jw-pagination', JwPagination)
const optionsOverrides1 = {
  durations: {
    global: 3000
  },
  icons: {
    enabled: false
  },
  labels: {
    success: '',
    warning: '',
    alert: ''
  },
  position: 'bottom-right'
}
const formShape1 = {
  skill_id: '',
  year: '',
  month: '',
  rating: ''
}
export default {
  name: 'admin_settings',
  data () {
    return {
      form: Object.assign({}, formShape1),
      tabOne: true,
      tabTwo: false,
      tabThree: false,
      skillslistlength: 0,
      skillslist: [],
      exampleItems: [],
      intlist: [],
      intlistlength: 0,
      exampleItems1: [],
      skillName: '',
      skillSearch: '',
      intSearch: '',
      showAddSkillModal: false,
      selectedSkillId: ''
    }
  },
  computed: {
    formStr () {
      return JSON.stringify(this.$v.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      skill_id: {
        required
      },
      year: {
        required
      },
      month: {
        required
      },
      rating: {
        required
      }
    }
  },
  created () {
    this.getSkillList()
    this.getInterviewerList()
  },
  methods: {
    onSubmitAddSkill () {
      if (this.validate()) {
        this.mainurl = '/org/' + this.selectedInterviewer + '/update_skill'
        var formData = {
          skill_id: this.form.skill_id,
          rating: this.form.rating,
          year: this.form.year,
          month: this.form.month
        }
        axios.post(BaseURLV3 + this.mainurl, formData, this.config).then(response => {
          if (response.data.success) {
            this.$awn.success(response.data.msg)
            this.cancel()
            this.getInterviewerList()
          } else {
            this.$awn.alert(response.data.msg, optionsOverrides1)
          }
        }).catch(e => {
          console.log(e)
        })
      }
    },
    getSkillList () {
      this.selectedSkillId = ''
      var data = {
        page: 1,
        search: this.skillSearch
      }
      const mainurl = '/org/list_skill'
      axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
        if (response.data.success) {
          this.skillslist = response.data.skill
          this.skillslistlength = response.data.total
          this.exampleItems = [...Array(response.data.total).keys()].map(i => (i))
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getInterviewerList () {
      var data = {}
      if (this.selectedSkillId !== '') {
        data = {
          page: 1,
          search: this.intSearch,
          skill_id: this.selectedSkillId
        }
        const mainurl = '/org/list_interviewer'
        axios.put(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
          if (response.data.success) {
            this.intlist = response.data.interviewer
            for (var i = 0; i < this.intlist.length; i++) {
              this.intlist[i].primarySkillName = ''
              for (var j = 0; j < this.intlist[i].u_p_skill.length; j++) {
                if (this.intlist[i].primarySkillName === '') {
                  this.intlist[i].primarySkillName = this.intlist[i].u_p_skill[j].skill.name
                } else {
                  this.intlist[i].primarySkillName = this.intlist[i].primarySkillName + ', ' + this.intlist[i].u_p_skill[j].skill.name
                }
              }
            }
            this.intlistlength = response.data.total
            this.exampleItems1 = [...Array(response.data.total).keys()].map(i => (i))
          }
        }).catch(e => {
          console.log(e)
        })
      } else {
        data = {
          page: 1,
          search: this.intSearch
        }
        const mainurl = '/org/list_interviewer'
        axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
          if (response.data.success) {
            this.intlist = response.data.interviewer
            for (var i = 0; i < this.intlist.length; i++) {
              this.intlist[i].primarySkillName = ''
              for (var j = 0; j < this.intlist[i].u_p_skill.length; j++) {
                if (this.intlist[i].primarySkillName === '') {
                  this.intlist[i].primarySkillName = this.intlist[i].u_p_skill[j].skill.name
                } else {
                  this.intlist[i].primarySkillName = this.intlist[i].primarySkillName + ', ' + this.intlist[i].u_p_skill[j].skill.name
                }
              }
            }
            this.intlistlength = response.data.total
            this.exampleItems1 = [...Array(response.data.total).keys()].map(i => (i))
          }
        }).catch(e => {
          console.log(e)
        })
      }
    },
    onChangePage (pageOfItems) {
      console.log('abc ', pageOfItems[0])
      if (pageOfItems.length > 0) {
        if (pageOfItems[0] === 0) {
          this.skip = 1
        } else {
          this.skip = (pageOfItems[0] / 25) + 1
        }
      }
      var data = {
        page: this.skip,
        search: this.skillSearch
      }
      const mainurl = '/org/list_skill'
      axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
        if (response.data.success) {
          this.skillslist = response.data.skill
        //   this.skillslistlength = response.data.teams.length
        }
      }).catch(e => {
        console.log(e)
      })
    },
    onChangePage1 (pageOfItems) {
      if (pageOfItems.length > 0) {
        if (pageOfItems[0] === 0) {
          this.skip = 1
        } else {
          this.skip = (pageOfItems[0] / 25) + 1
        }
      }
      var data = {}
      if (this.selectedSkillId !== '') {
        data = {
          page: this.skip,
          search: this.intSearch,
          skill_id: this.selectedSkillId
        }
        const mainurl = '/org/list_interviewer'
        axios.put(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
          if (response.data.success) {
            this.intlist = response.data.interviewer
            for (var i = 0; i < this.intlist.length; i++) {
              this.intlist[i].primarySkillName = ''
              for (var j = 0; j < this.intlist[i].u_p_skill.length; j++) {
                if (this.intlist[i].primarySkillName === '') {
                  this.intlist[i].primarySkillName = this.intlist[i].u_p_skill[j].skill.name
                } else {
                  this.intlist[i].primarySkillName = this.intlist[i].primarySkillName + ', ' + this.intlist[i].u_p_skill[j].skill.name
                }
              }
            }
          }
        }).catch(e => {
          console.log(e)
        })
      } else {
        data = {
          page: this.skip,
          search: this.intSearch
        }
        const mainurl = '/org/list_interviewer'
        axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
          if (response.data.success) {
            this.intlist = response.data.interviewer
            for (var i = 0; i < this.intlist.length; i++) {
              this.intlist[i].primarySkillName = ''
              for (var j = 0; j < this.intlist[i].u_p_skill.length; j++) {
                if (this.intlist[i].primarySkillName === '') {
                  this.intlist[i].primarySkillName = this.intlist[i].u_p_skill[j].skill.name
                } else {
                  this.intlist[i].primarySkillName = this.intlist[i].primarySkillName + ', ' + this.intlist[i].u_p_skill[j].skill.name
                }
              }
            }
          }
        }).catch(e => {
          console.log(e)
        })
      }
    },
    addSkill () {
      var data = {
        name: this.skillName
      }
      const mainurl = '/org/skill_add'
      axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
        if (response.data.success) {
          this.$awn.success(response.data.msg)
        } else {
          this.$awn.alert(response.data.msg, optionsOverrides1)
        }
        this.skillName = ''
      }).catch(e => {
        console.log(e)
      })
    },
    openAddSkill (data) {
      this.selectedInterviewer = data
      this.showAddSkillModal = true
    },
    onClose () {
      this.showAddSkillModal = false
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    cancel () {
      this.showAddSkillModal = false
    },
    viewInterviewers (skillId) {
      this.selectedSkillId = skillId
      this.tabOne = false
      this.tabThree = true
      this.getInterviewerList()
    }
  }
}

</script>

<style scoped>
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
.round {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  padding: 7px;
}

div.searchinput input[type="text"] {
  padding: 10px;
  font-size: 14px;
  border: 1px solid rgb(217, 215, 215);
  float: left;
  width: 200px;
  background: white;
  outline: none;
}

div.searchinput button {
  float: left;
  width: 50px;
  padding: 10px;
  background: #5bad2b;
  color: white;
  font-size: 14px;
  border: 1px solid rgb(217, 215, 215);
  border-left: none;
  cursor: pointer;
}

div.searchinput button:hover {
  background: green;
}

div.searchinput::after {
  content: "";
  clear: both;
  display: table;
}

.filterdata {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 10px;
  padding-top: 10px;
  padding-left: 10px;
}
</style>
